import { ACTION_NOOP } from '../constants';

export const noOp = () => ({
  type: ACTION_NOOP,
});
